import { useEffect } from "react";
import { useNavigate } from "react-router";
import { BASE_PRICE_GBP, PER_CLEANER_GBP } from "@/domain/billing/pricing";
import { NavBar } from "@/components/ds/NavBar/NavBar";
import { Hero } from "@/components/landing/Hero";
import { PainPoints } from "@/components/landing/PainPoints";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ClosedLoop } from "@/components/landing/ClosedLoop";
import { ForEveryone } from "@/components/landing/ForEveryone";
import { Pricing } from "@/components/landing/Pricing";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { usePageTitle } from "../hooks/usePageTitle";

const JSON_LD_ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "TidyRota",
  url: "https://tidyrota.com",
  description:
    "Scheduling and verified attendance for UK commercial cleaning companies.",
};

const JSON_LD_SOFTWARE = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "TidyRota",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  offers: {
    "@type": "Offer",
    priceCurrency: "GBP",
    price: String(BASE_PRICE_GBP),
    description: `Base price. Plus £${PER_CLEANER_GBP.toFixed(2)} per cleaner per month.`,
  },
};

export function LandingPage() {
  usePageTitle("TidyRota: Scheduling & Verified Attendance for UK Cleaning Companies");
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    fetch("/api/auth/me")
      .then(async (res) => {
        if (cancelled || !res.ok) return;
        const data = await res.json();
        const membership = data.data?.membership;
        if (membership?.isAccountCreator && !membership?.onboardingCompleted) {
          navigate("/onboarding", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      })
      .catch(() => { /* anonymous visitor, stay on the landing page */ });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(JSON_LD_ORGANIZATION),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(JSON_LD_SOFTWARE),
        }}
      />
      <NavBar />
      <main>
        <Hero />
        <PainPoints />
        <HowItWorks />
        <ClosedLoop />
        <ForEveryone />
        <Pricing />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
